import { CalendarInvitation } from './CalendarInvitation.js';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { rememberEntryView, sessionStore } from './entry.js';
import './styles.css';
rememberEntryView(location, history, sessionStore());
createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {location.hash.startsWith('#calendar-invite=') ? (
      <CalendarInvitation token={location.hash.slice(17)} />
    ) : (
      <App />
    )}
  </React.StrictMode>,
);
